export function useLoadingMounted() {
  const loading = ref(true)
  // Used to remove the loading class to prevent jumping ui on load
  const isMounted = useMounted()
  watch(isMounted, (active) => {
    if (active)
      loading.value = false
    else
      loading.value = true
  }, {
    immediate: true
  })

  return { loading }
}